import type { AppRouter } from "@server/trpc-router";
import { createTRPCReact } from "@trpc/react-query";

/**
 * tRPC-клиент витрины. Типы берутся из билда сервера (`@server/trpc-router`),
 * поэтому изменение процедуры ломает компиляцию фронта — это и есть
 * end-to-end типизация, ради которой контракт первичен.
 */
export const api = createTRPCReact<AppRouter>();
